import { useTabPanel } from '@react-aria/tabs'
import { useObjectRef } from '../../utils/useObjectRef'
import { TabListState } from '@react-stately/tabs'
import { AriaTabPanelProps } from '@react-types/tabs'
import Styles from './TabPanel.module.scss'

interface Props<T> extends AriaTabPanelProps {
  state: TabListState<T>
  style: any
}

export const TabPanel = <T,>({ state, style, ...props }: Props<T>) => {
  const ref = useObjectRef<HTMLDivElement>()
  const { tabPanelProps } = useTabPanel(props, state, ref)
  return (
    <div {...tabPanelProps} ref={ref} className={Styles.tabPanel} style={style}>
      {state.selectedItem?.props.children}
    </div>
  )
}
